import { render, staticRenderFns } from "./NitroWelcomeModal.vue?vue&type=template&id=2fe65e2b&scoped=true"
import script from "./NitroWelcomeModal.vue?vue&type=script&lang=js"
export * from "./NitroWelcomeModal.vue?vue&type=script&lang=js"
import style0 from "./NitroWelcomeModal.vue?vue&type=style&index=0&id=2fe65e2b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe65e2b",
  null
  
)

export default component.exports